import { Component, inject } from '@angular/core';
import { Entity } from '@app/core/model/entities/entity';
import { WorksService } from '@app/features/main/views/works/works.service';
import {
  ServerSideIndicatorStatusPanelComponent
} from '@app/shared/components/indicator-status-panel/server-side-indicator-status-panel/server-side-indicator-status-panel.component';
import { SelectParams } from '@app/shared/grid/datasource-utils';
import { IStatusPanelParams } from 'ag-grid-community';
import { merge, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

@Component({
  selector: 'works-indicator-status-panel',
  templateUrl: '../indicator-status-panel.component.html',
  styleUrls: ['../indicator-status-panel.component.scss'],
  standalone: false
})
export class WorksIndicatorStatusPanelComponent extends ServerSideIndicatorStatusPanelComponent {
  private worksService = inject(WorksService);

  /**
   * Set gridApi and add listen for row updates.
   */
  public agInit(params: IStatusPanelParams<Entity>): void {
    super.agInit(params);

    merge(
      this.worksService.workAdded$,
      this.worksService.workUpdated$,
      this.worksService.worksDeleted$
    )
      .subscribe(() => this.updateIndicatorsValues());
  }

  /**
   * Get aggregation result.
   * @param selectParams The parameters for the query. These include filtering, and aggregating.
   * @return Observable<Entity> Result of the aggregation query.
   */
  protected getAggregationResult(selectParams: SelectParams): Observable<Entity> {
    return this.worksService.loadWorksPage(selectParams)
      .pipe(first(), map(works => works.first()));
  }
}
